import * as React from 'react';
import {  Checkbox } from 'react-native-paper';
import { ScrollView, View, Text, StyleSheet, TouchableOpacity, Image } from 'react-native';
// import Icons from 'react-native-vector-icons/FontAwesome';
import { getBookMarks, addBookMark, clearAddBookMarkData, deleteBookMark, clearDeleteBookMarkData } from './../../store/actions';
import { connect } from 'react-redux';
import { bookmarksSelector } from './../../store/selectors';
import {Styles} from './../../components/UI-Components';
import Delete from '@material-ui/icons/Delete'
import Description from '@material-ui/icons/Description';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import Folder from '@material-ui/icons/Folder';
import List from '@material-ui/core/List';
import ShowContentScreen from './../showContentScreen';
import Header from "./../../components/Header";
import Container from '@material-ui/core/Container';
import LoadingComponent from "./../../components/LoaderComponent";
import ShowAlertComponent from './../../components/UI-Components/showAlertBox';

import { VIDEO, PDF, MATERIAL, CURRENT_AFFAIRS, EPUB, TEST, COURSE_MATERIAL, LIBRARY_MATERIAL,ARTICLES } from './../../store/constants/bookmarkConstants';

const ItemList = ({title, id, navigateTo, imgUrl, deleteItem, icon}) => (
    <div style ={{cursor :'pointer'}}>
    <List dense={true}  className='favourte-list' >
    <ListItem >
    <ListItemAvatar>
      {
        imgUrl ?
          <img src={imgUrl} style={{
            width: 40, height: 28, border:'1px solid #000',
             resizeMode: 'contain', alignSelf: 'center',
             backgroundColor: '#eaeaea'
          }}/>
        :
        <Avatar>
          <Description />
        </Avatar>
      }
    </ListItemAvatar>
    <ListItemText
      primary={title}
      onClick={() => typeof navigateTo === 'function' ? navigateTo() : null}
    //   secondary={secondary ? 'Secondary text' : null}
    />
    <ListItemSecondaryAction>
      <IconButton edge="end" aria-label="delete">
        <DeleteIcon  style={{color: 'red'}} onClick={() => deleteItem(id)} />
      </IconButton>
    </ListItemSecondaryAction>
  </ListItem>
  </List>
  </div>
//   <List.Item
//   style={{
//     paddingRight: 20,
//     paddingLeft: 30
//   }}
//   onPress={() => navigateTo()}
//   title={title || "title"} 
//   left={() => {
//     if(imgUrl) {
//       return <Image 
//         source={{uri: imgUrl}}
//         style={{width: 40, height: 28, borderWidth: 1, resizeMode: 'contain', alignSelf: 'center', backgroundColor: '#eaeaea'}}
//       />
//     }
//    return
//     // <Icons name={icon ||"file-pdf-o"}    
//     // style={styles.listIcons}
//     // color={Styles.primaryColor}
//     // />
      
//   }}
//   right={() => <TouchableOpacity
//     hitSlop={{
//       top: 8,
//       bottom: 8,
//       left: 8,
//       right: 8
//     }}
//     onPress={() => deleteItem(id)}
//   >
//     <Delete
//     //  name="trash-o" 
//     size={20} 
//     style={[styles.listIcons, {padding: 4}]}
//     />
//   </TouchableOpacity>
//   }

// />
)

class MyComponent extends React.Component {
  state = {
    showContent: false
  }

  componentDidMount(){
    this.props.getBookMarks();
  }

  componentDidUpdate(prevProps) {
    if(prevProps.deleteBookMarkResponse !== this.props.deleteBookMarkResponse) {
      if(this.props.deleteBookMarkResponse) {
        this.props.getBookMarks();
      }
    }
    // if(prevProps.pdfBookmarks !== this.props.pdfBookmarks) {
    //   if(this.props.pdfBookmarks) {
        
    //     console.log(this.props.pdfBookmarks, "as;d")
      
    //   }
    // }
  }

  componentWillUnmount() {
    this.props.clearDeleteBookMarkData();
  }

  _handlePress = (active) => {
    if(active === this.state.expanded) {
       
      return this.setState({expanded: false})
    }
    this.setState({
      expanded: active
    });
  }
   handleChange = (panel) => (event, expanded) => {
    // setExpanded(expanded ? panel : false);
    if(expanded){
        
        this.setState({expanded: true})
    }else{
        this.setState({expanded: false})
    }
  };
    

  render() {
    const { 
      currentAffairBookmarks,   
      materialBookmarks,
      videoBookmarks,
      pdfBookmarks,
      TestSeriesTestInfo,
      courseMaterial,
      libraryTopics,
      navigation,
      getBookMarksLoading,
      allBookMarksInfo,
      deleteBookMarkLoading,
      articleBookMarks
  } = this.props;
  // console.log(currentAffairBookmarks, "sdsd")
    return (
      <>
          <Header
                title="My Favourites "
                headerRight
                headerRightClick={() => this.props.history.push('/Home')}
                headerLeftClick={() => this.props.history.goBack()}
                backButton={true}
            // headerRightClick={() => alert()}
            />
            <Container maxWidth='lg'>
            <div className='full-height'>

          
            <View style={{flex: 1, backgroundColor: '#fff', marginTop: 10}}>
            
              <ScrollView style={{flex: 1}}>

                {
                currentAffairBookmarks?.bookmarks && currentAffairBookmarks?.bookmarks.length > 0 &&  
                  <Accordion expanded={this.state.expanded === CURRENT_AFFAIRS} onChange={() => this._handlePress(CURRENT_AFFAIRS)}>
                  <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                  style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', flex: 1}}
                >
                  <Folder/>
                  <Typography style={{marginLeft: 10, textTransform: 'uppercase'}}>{CURRENT_AFFAIRS}</Typography>
                </AccordionSummary>
                <AccordionDetails
                  style={{display: 'flex', flexDirection:'column',}}
                >
                {
                    currentAffairBookmarks.bookmarks.map((b, index) => (
                      <ItemList 
                        title={b.title} 
                        key={index}
                        id={b.id} 
                        deleteItem={this.props.deleteBookMark} 
                        imgUrl={b.image_url}
                        navigateTo={() => {
                          this.props.history.push(`/CurrentAffairs/${b.content_id}`, {
                            [b.content_name]: b.content_id,
                            from: 'MyFavourites',                  
                          })
                        }}
                      />
                    ))
                    }
                    
                  </AccordionDetails>
                </Accordion>
              }
              {
                pdfBookmarks?.bookmarks && pdfBookmarks?.bookmarks.length > 0 &&
              <Accordion expanded={this.state.expanded === PDF} onChange={() => this._handlePress(PDF)}>
                  <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                  style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', flex: 1}}
                >
                  <Folder/>
                  <Typography style={{marginLeft: 10, textTransform: 'uppercase'}}>{PDF}</Typography>
                </AccordionSummary>
                <AccordionDetails
                  style={{display: 'flex', flexDirection:'column',}}
                >
              {
                    pdfBookmarks.bookmarks.map(b => (
                      <ItemList 
                        title={b.title} 
                        id={b.id} 
                        deleteItem={this.props.deleteBookMark} 
                        imgUrl={b.image_url}
                        navigateTo={() => {
                          const meta = b.meta_data && JSON.parse(b.meta_data) || {}
                          this.setState({
                            showContent: true,
                            contentData: meta
                          })
                          
                          // this.props.history.push(`${b.screen_name}`, {
                          //   // id: b.content_id,
                          //   [b.content_name]: b.content_id,
                          //   from: 'MyFavourites',                     
                          //   contentUrl: b.content_url,
                          //   contentType: PDF,                  
                          //   ...meta
                          // })
                        }}
                      />
                    ))
                    }
                    
                </AccordionDetails>
              </Accordion>
              }
              
              {
                videoBookmarks?.bookmarks && videoBookmarks?.bookmarks.length > 0 &&
              <Accordion expanded={this.state.expanded === VIDEO} onChange={() => this._handlePress(VIDEO)}>
                  <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                  style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', flex: 1}}
                >
                  <Folder/>
                  <Typography style={{marginLeft: 10, textTransform: 'uppercase'}}>{VIDEO}</Typography>
                </AccordionSummary>
                <AccordionDetails
                  style={{display: 'flex', flexDirection:'column',}}
                >
              {
                    videoBookmarks.bookmarks.map(b => (
                      <ItemList 
                        title={b.title} 
                        id={b.id} 
                        deleteItem={this.props.deleteBookMark} 
                        imgUrl={b.image_url}
                        navigateTo={() => {
                          const meta = b.meta_data && JSON.parse(b.meta_data) || {}
                          this.setState({
                            showContent: true,
                            contentData: meta
                          })
                          
                          // this.props.history.push(`${b.screen_name}`, {
                          //   // id: b.content_id,
                          //   [b.content_name]: b.content_id,
                          //   from: 'MyFavourites',                     
                          //   contentUrl: b.content_url,
                          //   contentType: PDF,                  
                          //   ...meta
                          // })
                        }}
                      />
                    ))
                    }
                    
                </AccordionDetails>
              </Accordion>
              }
              {
                materialBookmarks?.bookmarks && materialBookmarks?.bookmarks.length > 0 &&
              <Accordion expanded={this.state.expanded === MATERIAL} onChange={() => this._handlePress(MATERIAL)}>
                  <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                  style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', flex: 1}}
                >
                  <Folder/>
                  <Typography style={{marginLeft: 10, textTransform: 'uppercase'}}>{MATERIAL}</Typography>
                </AccordionSummary>
                <AccordionDetails
                  style={{display: 'flex', flexDirection:'column',}}
                >
              {
                    materialBookmarks.bookmarks.map(b => (
                      <ItemList 
                        title={b.title} 
                        id={b.id} 
                        deleteItem={this.props.deleteBookMark} 
                        imgUrl={b.image_url}
                        navigateTo={() => {
                          const meta = b.meta_data && JSON.parse(b.meta_data) || {}
                          this.setState({
                            showContent: true,
                            contentData: meta
                          })
                          
                          // this.props.history.push(`${b.screen_name}`, {
                          //   // id: b.content_id,
                          //   [b.content_name]: b.content_id,
                          //   from: 'MyFavourites',                     
                          //   contentUrl: b.content_url,
                          //   contentType: PDF,                  
                          //   ...meta
                          // })
                        }}
                      />
                    ))
                    }
                    
                </AccordionDetails>
              </Accordion>
              }
              {
                courseMaterial?.bookmarks && courseMaterial?.bookmarks.length > 0 &&
              <Accordion expanded={this.state.expanded === COURSE_MATERIAL} onChange={() => this._handlePress(COURSE_MATERIAL)}>
                  <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                  style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', flex: 1}}
                >
                  <Folder/>
                  <Typography style={{marginLeft: 10, textTransform: 'uppercase'}}>{COURSE_MATERIAL}</Typography>
                </AccordionSummary>
                <AccordionDetails
                  style={{display: 'flex', flexDirection:'column',}}
                >
              {
                    courseMaterial.bookmarks.map(b => (
                      <ItemList 
                        title={b.title} 
                        id={b.id} 
                        deleteItem={this.props.deleteBookMark} 
                        imgUrl={b.image_url}
                        navigateTo={() => {
                          let _title = [];
                        const divide = b.title.split(":").join(",");
                        _title.push(divide.split(","));  
                          // const meta = b.meta_data && JSON.parse(b.meta_data) || {}
                          this.props.history.push(`/courseMaterial`, {
                            lessonPlannerId:  b.content_id,
                            from: 'MyFavourites',
                            title: _title                  
                          })
                          
                          // this.props.history.push(`${b.screen_name}`, {
                          //   // id: b.content_id,
                          //   [b.content_name]: b.content_id,
                          //   from: 'MyFavourites',                     
                          //   contentUrl: b.content_url,
                          //   contentType: PDF,                  
                          //   ...meta
                          // })
                        }}
                      />
                    ))
                    }
                    
                </AccordionDetails>
              </Accordion>
              }
              {
                libraryTopics?.bookmarks && libraryTopics?.bookmarks.length > 0 &&
              <Accordion expanded={this.state.expanded === LIBRARY_MATERIAL} onChange={() => this._handlePress(LIBRARY_MATERIAL)}>
                  <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                  style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', flex: 1}}
                >
                  <Folder/>
                  <Typography style={{marginLeft: 10, textTransform: 'uppercase'}}>{LIBRARY_MATERIAL}</Typography>
                </AccordionSummary>
                <AccordionDetails
                  style={{display: 'flex', flexDirection:'column',}}
                >
              {
                    libraryTopics.bookmarks.map(b => (
                      <ItemList 
                        title={b.title} 
                        id={b.id} 
                        deleteItem={this.props.deleteBookMark} 
                        imgUrl={b.image_url}
                        navigateTo={() => {
                          const meta = b.meta_data && JSON.parse(b.meta_data) || {}                               
                          this.props.history.push(`/topicLibraryBooks`, {                   
                            from: 'MyFavourites',
                            subjectName: b.title,
                            title: b.title,                                
                            ...meta
                          })
                          
                          // this.props.history.push(`${b.screen_name}`, {
                          //   // id: b.content_id,
                          //   [b.content_name]: b.content_id,
                          //   from: 'MyFavourites',                     
                          //   contentUrl: b.content_url,
                          //   contentType: PDF,                  
                          //   ...meta
                          // })
                        }}
                      />
                    ))
                    }
                    
                </AccordionDetails>
              </Accordion>
              }
                {/* <List.Section>            
                {
                currentAffairBookmarks?.bookmarks && currentAffairBookmarks?.bookmarks.length > 0 && 
                <List.Accordion
                  titleStyle={{color: '#000'}}
                  title="Current Affairs"
                  left={props => <Description {...props} icon="folder"  style={{color: '#000'}}
                    />}
                  expanded={this.state.expanded === CURRENT_AFFAIRS}
                //   onPress={() => this._handlePress(CURRENT_AFFAIRS)}
              >
                
              </List.Accordion> */}
                {/* } */}

                {/* {
                pdfBookmarks?.bookmarks && pdfBookmarks?.bookmarks.length > 0 && 
                <List.Accordion
                  titleStyle={{color: '#000'}}
                  title="PDF"
                  left={props => <List.Icon {...props} icon="folder" color={'#000'} />}
                  expanded={this.state.expanded === PDF}
                  onPress={() => this._handlePress(PDF)}
              >
                {
                pdfBookmarks.bookmarks.map(b => (
                  <ListItem 
                    title={b.title} 
                    id={b.id} 
                    deleteItem={this.props.deleteBookMark} 
                    imgUrl={b.image_url}
                    navigateTo={() => {
                      const meta = b.meta_data && JSON.parse(b.meta_data) || {}
                      navigation.navigate(b.screen_name, {
                        // id: b.content_id,
                        [b.content_name]: b.content_id,
                        from: 'MyFavourites',                     
                        contentUrl: b.content_url,
                        contentType: PDF,                  
                        ...meta
                      })
                    }}
                  />
                ))
                }
              </List.Accordion>
                } */}
    {/* {
                materialBookmarks?.bookmarks && materialBookmarks?.bookmarks.length > 0 && 
                <List.Accordion
                titleStyle={{color: '#000'}}
                  title="MATERIAL"
                  left={props => <List.Icon {...props} icon="folder" color={'#000'} />}
                  expanded={this.state.expanded === MATERIAL}
                  onPress={() => this._handlePress(MATERIAL)}
              >
                {
                materialBookmarks.bookmarks.map(b => (
                  <ListItem 
                    title={b.title} 
                    id={b.id} 
                    icon={'file'}
                    deleteItem={this.props.deleteBookMark} 
                    imgUrl={b.image_url}
                    navigateTo={() => {
                      const meta = b.meta_data && JSON.parse(b.meta_data) || {}
                      navigation.navigate(b.screen_name, {
                        [b.content_name]: b.content_id,
                        from: 'MyFavourites',
                        content_type: EPUB,
                        contentUrl: b.content_url,
                        contentType: PDF,                  
                        ...meta
                      })
                    }}
                  />
                ))
                }
              </List.Accordion>
                } */}

    {/* {
                videoBookmarks?.bookmarks && videoBookmarks?.bookmarks.length > 0 && 
                <List.Accordion
                titleStyle={{color: '#000'}}
                  title="VIDEOS"
                  left={props => <List.Icon {...props} icon="folder" color={'#000'} />}
                  expanded={this.state.expanded === VIDEO}
                  onPress={() => this._handlePress(VIDEO)}
              >
                {
                videoBookmarks.bookmarks.map(b => (
                  <ListItem 
                    title={b.title} 
                    id={b.id} 
                    icon={'play-circle-o'}
                    deleteItem={this.props.deleteBookMark} 
                    imgUrl={b.image_url}
                    navigateTo={() => {
                      const meta = b.meta_data && JSON.parse(b.meta_data) || {}
                      // const meta = b.meta_date && JSON.parse(b.meta_date) || {}                
                      navigation.navigate(b.screen_name, {
                        [b.content_name]: b.content_id,
                        from: 'MyFavourites',
                        content_type: EPUB,
                        contentUrl: b.content_url,
                        contentType: PDF,                  
                        ...meta
                      })
                    }}
                  />
                ))
                }
              </List.Accordion>
                } */}


                
              {/* </List.Section> */}
              {
                
                pdfBookmarks?.bookmarks && pdfBookmarks?.bookmarks.length === 0 &&
                materialBookmarks?.bookmarks && materialBookmarks?.bookmarks.length === 0 &&
                videoBookmarks?.bookmarks && videoBookmarks?.bookmarks.length === 0 &&
                TestSeriesTestInfo?.bookmarks && TestSeriesTestInfo?.bookmarks.length === 0 &&
                libraryTopics?.bookmarks && libraryTopics?.bookmarks.length === 0 &&
                courseMaterial?.bookmarks && courseMaterial?.bookmarks.length === 0 &&
                currentAffairBookmarks?.bookmarks && currentAffairBookmarks?.bookmarks.length === 0 &&
                !deleteBookMarkLoading &&
                !getBookMarksLoading &&
                <View style={{justifyContent: 'center', alignItems: 'center', marginTop: 50}}>
                  <Text style={{fontSize: 16}}>You have no Favourites yet</Text>
                </View>
              }
            </ScrollView>
          </View>
          {
                    this.state.showContent ?
                    <ShowContentScreen
                    contentData={this.state.contentData}
                    open={this.state.showContent}
                    handleClose={() => this.setState({showContent: false})}
                    />
                    : null
            }
          </div>
          </Container>
      </>    
    );
  }
}

const mapStateToProps = state => {

  const bookmarkInfo = bookmarksSelector(state.allBookMarks);

  return {
    currentAffairBookmarks: bookmarkInfo?.currentAffairs,
    articleBookMarks:bookmarkInfo?.articles,
    videoBookmarks: bookmarkInfo?.video,
    materialBookmarks: bookmarkInfo?.material,
    pdfBookmarks: bookmarkInfo?.pdf,
    TestSeriesTestInfo: bookmarkInfo?.test, 
    courseMaterial: bookmarkInfo?.courseMaterial,
    libraryTopics: bookmarkInfo?.libraryTopics,
    bookmarkInfo,
    deleteBookMarkResponse: state?.deleteBookMark?.response,
    deleteBookMarkLoading: state?.deleteBookMark?.loading,
    deleteBookMarkError: state?.deleteBookMark?.error,
    deleteBookMarkErrorInfo: state?.deleteBookMark?.errorInfo,
    allBookMarksInfo:  state?.allBookMarks?.response?.bookmarks,
    getBookMarksLoading: state?.allBookMarks?.loading,
   
  }
}

export default connect(mapStateToProps, {getBookMarks, addBookMark, clearAddBookMarkData,  deleteBookMark, clearDeleteBookMarkData})( MyComponent);



const styles = StyleSheet.create({
  listIcons: {
    margin: 12,
    alignSelf: 'center',
    // borderWidth: 1,  
  }
})